import React from "react";

import { LoadingRow, Spinner, StyledMd3Button } from "./styles";
import type {
  Md3ButtonColor,
  Md3ButtonSize,
  Md3ButtonVariant,
} from "./palette";

export type Md3ButtonProps = {
  children?: React.ReactNode;
  title?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  variant?: Md3ButtonVariant;
  color?: Md3ButtonColor;
  size?: Md3ButtonSize;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
  "aria-label"?: string;
  className?: string;
};

export function Md3Button({
  children,
  title,
  onClick,
  type = "button",
  variant = "filled",
  color = "primary",
  size = "medium",
  disabled = false,
  loading = false,
  fullWidth = false,
  icon,
  iconRight,
  "aria-label": ariaLabel,
  className,
}: Md3ButtonProps) {
  const isDisabled = disabled || loading;
  const label = title ?? (typeof children === "string" ? children : undefined);

  return (
    <StyledMd3Button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      $variant={variant}
      $color={color}
      $size={size}
      $fullWidth={fullWidth}
      aria-label={ariaLabel ?? label}
      aria-busy={loading || undefined}
      className={className}
    >
      {loading ? (
        <LoadingRow>
          <Spinner aria-hidden />
          Carregando…
        </LoadingRow>
      ) : (
        <>
          {icon}
          {children ?? title}
          {iconRight}
        </>
      )}
    </StyledMd3Button>
  );
}

export type { Md3ButtonColor, Md3ButtonSize, Md3ButtonVariant };
